import { useEffect } from "react";

export const useDocumentClassName = (className) => {
  useEffect(() => {
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  }, [className]);
};
